import React, { useState } from 'react'
import {
  Btn,
  CustomCheckbox,
  CustomDropdown,
  CustomModal,
  InputCnpj,
  InputText,
} from '../../../../../components'
import * as SystemHttp from '../../../../../services/api/https/system/system.http'
import * as ClientHttp from '../../../../../services/api/https/registration/client.http'
import { errorHandler } from '../../../../../services/util/error.service'

const INIT_STATE = {
  isLoading: false,
  ufs: [],
  selectedUF: '',
  cities: [],
  cliente: {
    company_code: '',
    nomeFantasia: '',
    razaoSocial: '',
    cnpj: '',
    city: '',
    address: '',
    district: '',
    number: '',
    makeParcialReturn: true,
    actived: true,
  },
}

// --------------------------------------
// Modal Utilizado para cadastramento
// de clientes importados que não estão
// cadastrados
// --------------------------------------

function ModalCliente2({ visible, selectedCliente, companyId, onResponse }) {
  // Hooks
  const [state, setState] = useState({ ...INIT_STATE })

  React.useEffect(() => {
    getInitInfo()
    if (selectedCliente && companyId) {
      setState(prev => ({ ...prev, cliente: selectedCliente }))
    } else {
      setState(prev => ({ ...INIT_STATE }))
    }
  }, [visible])

  // Events
  const onBtnSalvarClicked = async () => {
    try {
      const cliente = await ClientHttp.registerClient2(state.cliente, companyId)
      onResponse('success', cliente)
    } catch (error) {
      onResponse('error', errorHandler(error))
    }
  }

  const onEstadoChange = async estado => {
    try {
      const { id } = estado
      setState(prev => ({ ...prev, isLoading: true }))
      const cities = await SystemHttp.getCities(id)
      setState(prev => ({ ...prev, isLoading: false, cities, selectedUF: estado }))
    } catch (e) {
      onResponse('error', errorHandler(e))
    }
  }

  // Helpers
  const getInitInfo = async () => {
    try {
      setState(prev => ({ ...prev, isLoading: true }))
      const ufs = await SystemHttp.getUfs()
      setState(prev => ({ ...prev, isLoading: false, ufs }))
    } catch (error) {
      onResponse('error', errorHandler(error))
    }
  }

  const updateClienteInfo = (fieldName, value) => {
    setState(prev => {
      prev.cliente[fieldName] = value
      return { ...prev }
    })
  }

  // Render
  return (
    <CustomModal
      header="Cliente Não Cadastrado"
      isVisible={visible}
      onClose={() => onResponse('close')}
    >
      <form className="p-grid" style={{ width: 800 }}>
        <div className="p-col-12">
          <InputText disabled={true} label="Código :" value={state.cliente.company_code} />
        </div>
        <div className="p-col-6">
          <InputText
            label="Razão Social :"
            marginTop={10}
            value={state.cliente.razaoSocial}
            onChange={value => updateClienteInfo('razaoSocial', value.toUpperCase())}
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Nome Fantasia :"
            marginTop={10}
            value={state.cliente.nomeFantasia}
            onChange={value => updateClienteInfo('nomeFantasia', value.toUpperCase())}
          />
        </div>
        <div className="p-col-4">
          <InputCnpj
            label="CNPJ :"
            marginTop={10}
            value={state.cliente.cnpj}
            onChange={({ value }) => updateClienteInfo('cnpj', value)}
          />
        </div>
        <div className="p-col-4">
          <CustomDropdown
            optionLabel="name"
            options={state.ufs}
            value={state.selectedUF}
            label="Estado :"
            filter={true}
            onChange={onEstadoChange}
          />
        </div>
        <div className="p-col-4">
          <CustomDropdown
            disabled={state.isLoading}
            optionLabel="name"
            options={state.cities}
            value={state.cliente.city}
            label="Cidade :"
            filter={true}
            onChange={value => updateClienteInfo('city', value)}
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Endereço :"
            marginTop={10}
            value={state.cliente.address}
            onChange={value => updateClienteInfo('address', value)}
          />
        </div>
        <div className="p-col-6">
          <InputText
            label="Bairro :"
            marginTop={10}
            value={state.cliente.district}
            onChange={value => updateClienteInfo('district', value)}
          />
        </div>
        <div className="p-col-4">
          <InputText
            label="Número :"
            marginTop={10}
            value={state.cliente.number}
            onChange={value => updateClienteInfo('number', value)}
          />
        </div>
        <div className="p-col-4" style={{ paddingTop: 42 }}>
          <CustomCheckbox
            checked={state.cliente.makeParcialReturn}
            onChange={value => updateClienteInfo('makeParcialReturn', value)}
          >
            Faz Devolução Parcial
          </CustomCheckbox>
        </div>
        <div className="p-col-4" style={{ paddingTop: 42 }}>
          <CustomCheckbox
            checked={state.cliente.actived}
            onChange={value => updateClienteInfo('actived', value)}
          >
            Ativo
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <Btn isLoading={state.isLoading} onClick={onBtnSalvarClicked}>
            Salvar
          </Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default ModalCliente2
